<mat-form-field class="generic-chip-list" appearance="fill">
  <mat-label>{{ label }}</mat-label>

  <mat-chip-list #chipList [attr.aria-label]="label" >
    <mat-chip *ngFor="let item of control.value" (removed)="remove(item)">
      {{ item }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>

    <input
      #itemInput
      placeholder="Select {{ label | lowercase }}..."
      [formControl]="itemCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-list>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" >
    <mat-option *ngFor="let item of filteredItems | async" [value]="item">
      {{ item }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
